import React, { useEffect, useState, useRef } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import debounce from 'lodash/debounce';
import { get } from 'lodash';
import { Menu, MenuItem, useMediaQuery } from '@material-ui/core';
// import { useTheme } from '@material-ui/core/styles';
import { breakpoints } from '../../../../styles/themes/vad/constants';

import {
  COMPONENT_CONTAINER,
  COMPONENT_NAME,
  COMPONENT_GRID_BLOCK,
  COMPONENT_GRID_CONTAINER,
  COMPONENT_SUBNAVIGATION_LIST_WRAP,
  COMPONENT_SUBNAVIGATION_LIST,
} from './locators';

import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import clsx from 'clsx';

import Container from '../../../components/molecules/Container';
import Grid from '../../../components/molecules/Grid';
import Typography from '../../../components/atoms/Typography';
import Button from '../../../components/atoms/Button';
import StickyBar from '../../../components/atoms/StickyBar';
import SvgIcon from '../../../components/atoms/Svg/';
import { canUseDOM } from '../../../utils/canUseDOM';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import { getDictionaryText } from '../../../utils/getDictionaryText';

import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import { getPageName, getComponentName } from '../../../utils/getPageComponentInfo';
import { createDynamicLabels } from '../../../../utils/analytics';
import { pageContentType } from '../../../utils/getContentType';

import useStyles from './style';

const SubNav = (props) => {
  const { fields, params } = props;
  const [maxSubNavItemsCount, setmaxSubNavItemsCount] = useState(undefined);
  const linksWidthArr = useRef([]);
  const buttonRef = useRef(null);
  const { customContentList } = fields;
  const subNavigationList =
    customContentList &&
    customContentList.filter(item => item.includeInNavigation);
  const contentType = pageContentType(props).toLowerCase();
  const classes = useStyles({ contentType });
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = useMediaQuery(`(max-width:${breakpoints.values.md}px)`);

  const trigger = useScrollTrigger({
    threshold: 10,
  });

  function handleResize() {
    if (!buttonRef.current) {
      return;
    }
    buttonRef.current.classList.remove('remove');
    buttonRef.current.classList.add('hide');
    let linksArr,
      i = 0,
      // StopWidth is available space.
      stopWidth = document.querySelector('.subNavigationListWrap').clientWidth,
      moreBtnWidth = buttonRef.current.clientWidth;
    // If we do not have links' width array. Then we will create one.
    // Otherwise, we are using the already created one.
    if (linksWidthArr.current.length === 0) {
      const listItems = document.querySelector('.subNavigationList').childNodes;
      linksArr = Array.prototype.map.call(listItems, item => item.clientWidth ? item.clientWidth : 0);
      linksWidthArr.current = linksArr;
    } else {
      linksArr = linksWidthArr.current;
    }
    stopWidth -= moreBtnWidth;
    for (; i < linksArr.length; i++) {
      if (stopWidth >= linksArr[i]) {
        stopWidth -= linksArr[i];
      } else {
        break;
      }
    }
    // 'i' represents the max links that can be displayed.
    //  In case of maxSubNavItems = undefined, we are setting the value to 100.
    if (i < parseInt(params.maxSubNavItems || 100)) {
      setmaxSubNavItemsCount(i);
      if (i === linksArr.length) {
        buttonRef.current.classList.add('remove');
      }
    } else if (linksArr.length > parseInt(params.maxSubNavItems)) {
      setmaxSubNavItemsCount(parseInt(params.maxSubNavItems));
    } else {
      buttonRef.current.classList.add('remove');
    }
    buttonRef.current.classList.remove('hide');
  }

  const handleResizeDeb = debounce(handleResize, 50);

  useEffect(() => {
    if (canUseDOM) {
      if (isMobile) {
        let el = document.querySelector('.subNavigationList a.active');
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          });
        }
      } else {
        window.addEventListener('resize', handleResizeDeb);
        return () => window.removeEventListener('resize', handleResizeDeb);
      }
    }
  }, [isMobile]);

  useEffect(() => {
    setTimeout(() => {
      handleResize();
    }, 0);
  }, []);

  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [isMoreButtonActive, setIsMoreButtonActive] = useState(false);

  useEffect(() => {
    if (isMoreButtonActive && canUseDOM) {
      window.addEventListener('scroll', handleClose);
      return () => window.removeEventListener('scroll', handleClose);
    }
  }, [isMoreButtonActive]);

  if (!subNavigationList || subNavigationList.length === 0) {
    return null;
  }

  const getSubNavLink = (index, displayName, url, active) => (
    <li
      key={index}
      className={`item-${index + 1} ${classes.subNavigationListItem}`}
    >
      <Typography
        data-id={analyticsData.dataIds.topNavLinkClick}
        data-link={createDynamicLabels([getPageName(props), getComponentName(props), displayName])}
        variant={'body2'}
        component="a"
        href={url}
        className={`${active ? 'active' : ''}`}
      >
        {displayName}
      </Typography>
    </li>
  );

  const renderSubNavigationList = () => {
    const subNavList =
      subNavigationList &&
      subNavigationList.length > 0 &&
      subNavigationList.map((item, index) => {
        const { displayName, url, active } = item || '';
        if (!isMobile) {
          return (
            displayName &&
            (maxSubNavItemsCount ? index < maxSubNavItemsCount : true) &&
            getSubNavLink(index, displayName, url, active)
          );
        } else {
          return displayName && getSubNavLink(index, displayName, url, active);
        }
      });

    return subNavList;
  };

  const renderMoreMenuList = () => {
    const subNavMoreList =
      subNavigationList &&
      subNavigationList.map((item, index) => {
        const { displayName, url, active } = item || '';
        const isMoreMenu = index >= maxSubNavItemsCount;
        if (!isMoreButtonActive && isMoreMenu && active) {
          setIsMoreButtonActive(true);
        }
        return (
          displayName &&
          isMoreMenu && (
            <MenuItem key={index} className={`item-${index}`}>
              <Typography
                data-id={get(analyticsData, 'dataIds.topNavLinkClick')}
                data-link={displayName}
                variant={`${active ? 'body2Bold' : 'body2'}`}
                component="a"
                href={url}
                className={`${active ? 'active' : ''}`}
              >
                {displayName}
              </Typography>
            </MenuItem>
          )
        );
      });
    return subNavMoreList;
  };

  const handleClick = event => {
    setIsMoreButtonActive(true);
    setMoreMenuAnchorEl(event.currentTarget);

    setTimeout(() => {
      document.querySelector('body').removeAttribute('style');
      document.querySelector('header').style.paddingRight = 0;
      // document.body
      //   .querySelector(`[data-locator="${COMPONENT_SLIDER}"]`)
      //   .removeAttribute('style');
    }, 0);
  };

  const handleClose = () => {
    setIsMoreButtonActive(false);
    setMoreMenuAnchorEl(null);
  };

  const renderUI = () => {
    return (
      <Grid className={classes.root} data-locator={COMPONENT_GRID_BLOCK}>
        <Grid
          container
          spacing={0}
          classes={{
            root: `${classes.root}`,
          }}
          alignItems="center"
          data-locator={COMPONENT_GRID_CONTAINER}
        >
          <Grid item xs={12}>
            <div
              role="navigation"
              aria-label="sub-navigation"
              className={`subNavigationListWrap ${classes.subNavigationListWrap}`}
              data-locator={COMPONENT_SUBNAVIGATION_LIST_WRAP}
            >
              <ul
                className={`subNavigationList ${classes.subNavigationList}`}
                data-locator={COMPONENT_SUBNAVIGATION_LIST}
              >
                {renderSubNavigationList()}
              </ul>
              {!isMobile && (
                <div className={clsx(classes.moreNavItemWrap, 'hide')} ref={buttonRef}>
                  <Button
                    buttonType="primary"
                    isStartIcon={true}
                    hasBorder={false}
                    className={`${classes.moreItemButton} ${isMoreButtonActive ? 'active' : ''
                      }`}
                    startIcon={<SvgIcon name="MoreHorizIcon" />}
                    onClick={handleClick}
                    aria-haspopup="true"
                  >
                    <Typography
                      variant="body2Bold"
                      component="span"
                      className={classes.moreTxt}
                    >
                      {getDictionaryText('moreLabel')}
                    </Typography>
                  </Button>
                  <Menu
                    elevation={0}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    anchorEl={moreMenuAnchorEl}
                    keepMounted
                    open={Boolean(moreMenuAnchorEl)}
                    onClose={handleClose}
                    className={classes.moreMenu}
                  >
                    {renderMoreMenuList()}
                  </Menu>
                </div>
              )}
            </div>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  return isMobile ? (
    <div
      className={clsx(classes.subNavigationWrap, !trigger && 'header-added')}
      data-locator={COMPONENT_NAME}
    >
      {renderUI()}
    </div>
  ) : (
    <Container data-locator={COMPONENT_CONTAINER}>
      <StickyBar
        className={classes.subNavigationWrap}
        data-locator={COMPONENT_NAME}
        mobileBottomSticky={false}
      >
        {renderUI()}
      </StickyBar>
      <div id="ghostDiv"></div>
    </Container>
  );
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(SubNav))
);
